export default __webpack_public_path__ + "static/media/field.1af6d925.jpg";